import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Research } from "@/components/site/Research";
import { Topics } from "@/components/site/Topics";
import { Atlas } from "@/components/site/Atlas";
import { Writings } from "@/components/site/Writings";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { getSiteSettings, getPapers, getTopics, getWritings } from "@/lib/api";

export default function Home() {
  const [settings, setSettings] = useState(null);
  const [papers, setPapers] = useState([]);
  const [topics, setTopics] = useState([]);
  const [writings, setWritings] = useState([]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    Promise.all([getSiteSettings(), getPapers(), getTopics(), getWritings()])
      .then(([s, p, t, w]) => {
        setSettings(s);
        setPapers(p);
        setTopics(t);
        setWritings(w);
      })
      .catch((e) => console.error("Failed to load content", e));
  }, []);

  return (
    <div className="App relative">
      <div className="grain" />
      <Navbar settings={settings} />
      <main>
        <Hero settings={settings} />
        <EditorialMarquee />
        {papers.length > 0 && <Research papers={papers} />}
        {topics.length > 0 && <Topics topics={topics} />}
        <Atlas settings={settings} />
        {writings.length > 0 && <Writings writings={writings} settings={settings} />}
        <About settings={settings} />
        <Contact settings={settings} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
